import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
/*import { RouterTestingModule } from '@angular/router/testing';*/
import { DatePipe } from '@angular/common';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { CustomValidatorsService } from './custom-validators.service';
import { AuthGuardService } from './auth-guard.service';
import { CreateAgencyFormComponent } from '../create-agency/create-agency-form/create-agency-form.component';
/*import { SearchFilterPipe } from './search-filter.pipe';*/
import { ValidateOnBlurDirective } from './validate-on-blur.directive';
import { RestrictedInputDirective } from './directives/restricted-input.directive';
import { NgxSelectModule } from 'ngx-select-ex';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
	NgxSelectModule,
    ReactiveFormsModule,
    RouterModule,
    BsDatepickerModule.forRoot(),
    BsDropdownModule.forRoot(),
    PaginationModule.forRoot()    
    /*RouterTestingModule*/
  ],
  declarations: [CreateAgencyFormComponent, ValidateOnBlurDirective, RestrictedInputDirective],
  providers : [CustomValidatorsService, DatePipe, AuthGuardService],
  exports : [
    FormsModule, 
    ReactiveFormsModule, 
    TranslateModule, 
    CreateAgencyFormComponent,
    DatePipe,
    BsDatepickerModule,
    BsDropdownModule,
	NgxSelectModule,
    PaginationModule      
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/shared/shared.module.ts